import { startTransition, useState } from 'react'
import { isEmpty } from 'lodash'
import EnterpriseIcon, { CancelIcon } from '@enterprise-ui/icons'
import { Autocomplete } from '@enterprise-ui/canvas-ui-react-autocomplete'
import { Button, Grid, Input } from '@enterprise-ui/canvas-ui-react'
const filterLabels = {
  shipmentId: 'Shipment Id',
  trackingNum: 'Tracking Number',
  pegasusId: 'Pegasus Ids',
}
export default function AllShipmentsFiltersCanvas(props = {}) {
  const {
    filtersOptions = {},
    filterValues = {},
    setSelectedFilters = () => {},
  } = props
  const [selectedPegasusIds, setSelectedPegasusIds] = useState('')

  const handleUpdate = (selectedValue = '', filterName = '') => {
    const updFilterValues = Object.assign({}, filterValues, {
      [filterName]: selectedValue,
    })

    const updFilterValuesObj = Object.entries(updFilterValues).reduce(
      (a, [k, v]) => (isEmpty(v) ? a : ((a[k] = v), a)),
      {}
    )
    startTransition(() => {
      setSelectedFilters(updFilterValuesObj)
    })
  }
  const clearPegasusIds = () => {
    setSelectedPegasusIds('')
    handleUpdate('', 'pegasusId')
  }
  return (
    <Grid.Container
      style={{ paddingLeft: '12px' }}
      spacing={2}
      justify={'start'}
      align="center"
    >
      <Grid.Item
        style={{
          flexWrap: 'nowrap',
          flex: 0.15,
          color: '#666',
          fontSize: '16px',
          fontWeight: 600,
          top: '2%',
        }}
      >
        <span>{'Filter By'}</span>
      </Grid.Item>
      {Object.keys(filtersOptions)?.map((filterName = '') => {
        const optionsList = filtersOptions[filterName] ?? []
        let cmp = {}
        filterName !== 'pegasusId'
          ? (cmp = (
              <Grid.Item
                style={{ marginTop: '1%', width: 360, marginRight: '10px' }}
              >
                <Autocomplete
                  label={filterLabels[filterName] ?? ''}
                  options={optionsList}
                  disabled={!optionsList?.length}
                  onUpdate={(id, value) => {
                    handleUpdate(value, filterName)
                  }}
                  value={filterValues[filterName] ?? []}
                  multiselect
                  grow={false}
                />
              </Grid.Item>
            ))
          : (cmp = (
              <Grid.Item
                xs={12}
                md={12}
                lg={12}
                style={{
                  marginTop: '1%',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <div>
                  <Input.Label
                    style={{
                      color: '#666 !important',
                      fontSize: '14px !important',
                      fontWeight: 'initial',
                    }}
                    htmlFor="peg_ids"
                  >
                    {filterLabels[filterName] ?? ''}
                  </Input.Label>
                  <Input.Textarea
                    id="peg_ids"
                    size="dense"
                    style={{
                      minHeight: '50px',
                      height: '50px',
                      fontWeight: 'initial',
                      width: '400px',
                    }}
                    label={filterLabels[filterName] ?? ''}
                    placeholder={filterLabels[filterName] ?? ''}
                    value={selectedPegasusIds || ''}
                    onChange={(event) =>
                      setSelectedPegasusIds(event.target.value)
                    }
                  />
                </div>
                <Button
                  size="small"
                  type="primary"
                  style={{ margin: '0 10px', fontSize: '14px !important' }}
                  disabled={!selectedPegasusIds.length}
                  onClick={() => handleUpdate(selectedPegasusIds, filterName)}
                >
                  Apply Pegasus Id
                </Button>
                <Button
                  id="clearall"
                  type="ghost"
                  size="small"
                  style={{ fontSize: '14px !important' }}
                  disabled={!selectedPegasusIds.length}
                  onClick={() => clearPegasusIds()}
                >
                  <EnterpriseIcon icon={CancelIcon} /> CLEAR ALL Pegasus Ids
                </Button>
              </Grid.Item>
            ))
        return cmp
      })}
    </Grid.Container>
  )
}
